import React from 'react';
import { formatDistance } from '../utils/pathCalculations';
import { calculateEfficiency } from '../utils/efficiencyCalculations';
import '../../../styles/modes/compareMode.css';

const DetailedComparison = ({ 
  expandedDetails, 
  autoSegments, 
  customSegments, 
  autoPathInfo, 
  customPathInfo,
  pathDifference
}) => {
  if (!expandedDetails) return null;
  
  return (
    <div className="segments-comparison">
      <h6>Detailed Path Segment Comparison</h6>
      
      {/* Auto path segments table */}
      {autoSegments.length > 0 && (
        <div className="segment-table-container auto">
          <h6>Auto Path Segments</h6>
          <table className="segments-table">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>Distance</th>
              </tr>
            </thead>
            <tbody>
              {autoSegments.map((segment, index) => (
                <tr key={`auto-segment-${index}`}>
                  <td>{segment.from.name}</td>
                  <td>{segment.to.name}</td>
                  <td>{formatDistance(segment.distance)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{formatDistance(autoPathInfo.distance)}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      
      {/* Custom path segments table */}
      {customSegments.length > 0 && (
        <div className="segment-table-container custom">
          <h6>Custom Path Segments</h6>
          <table className="segments-table">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>Distance</th>
              </tr>
            </thead>
            <tbody>
              {customSegments.map((segment, index) => {
                // Try to find matching segment in auto path
                const matchingAutoSegment = autoSegments.find(
                  auto => (auto.from.id === segment.from.id && auto.to.id === segment.to.id) ||
                          (auto.from.id === segment.to.id && auto.to.id === segment.from.id)
                );
                
                return (
                  <tr key={`custom-segment-${index}`}>
                    <td>{segment.from.name}</td>
                    <td>{segment.to.name}</td>
                    <td>{formatDistance(segment.distance)}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{formatDistance(customPathInfo.distance)}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      
      {/* Path optimization suggestions */}
      {customSegments.length > 0 && !pathDifference.isCustomBetter && (
        <div className="optimization-suggestions">
          <h6>Optimization Suggestions</h6>
          <ul className="suggestions-list">
            {customSegments.map((segment, index) => {
              // Try to find matching auto path segment
              const matchingAutoSegment = autoSegments.find(
                auto => (auto.from.id === segment.from.id && auto.to.id === segment.to.id) ||
                        (auto.from.id === segment.to.id && auto.to.id === segment.from.id)
              );
              
              if (matchingAutoSegment && segment.distance > matchingAutoSegment.distance * 1.1) {
                // If custom path segment is 10% longer than auto path, provide suggestion
                return (
                  <li key={`suggestion-${index}`} className="suggestion-item">
                    <span className="worse">Path segment {segment.from.name} → {segment.to.name}</span> 
                    is 
                    <span className="worse"> {((segment.distance / matchingAutoSegment.distance - 1) * 100).toFixed(1)}%</span>
                    longer than algorithm path, consider trying alternative routes
                  </li>
                );
              }
              return null;
            }).filter(Boolean)}
            
            {/* If no specific suggestions, provide general advice */}
            {customSegments.filter((segment, index) => {
              const matchingAutoSegment = autoSegments.find(
                auto => (auto.from.id === segment.from.id && auto.to.id === segment.to.id) ||
                        (auto.from.id === segment.to.id && auto.to.id === segment.from.id)
              );
              return matchingAutoSegment && segment.distance > matchingAutoSegment.distance * 1.1;
            }).length === 0 && (
              <li>
                Path sequence may need optimization. Try adjusting the order of points to reduce total distance.
              </li>
            )}
          </ul>
        </div>
      )}

    </div>
  );
};

export default DetailedComparison; 